import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  ColourThemes,
  Directions,
  PaymentTypes,
  SubmitInitiators,
  Versions,
} from '@cashier/cashier-model';

export interface CashierConfiguration {
  userId: string;
  sessionId: string;
  merchantId: string;
  activeType: PaymentTypes | null;
  currency: string;
  bonusCode: string;
  termsUrl: string;
  platform: string;
  hostUrl: string;
  language: string;
  accountId: string;
  pgwMerchantId: string;
  cashierHostLocation: string;
  customerBalance: string;
  webView: string | boolean;
  direction: Directions;
  country: string;
  orderId: string;
  initialAmount: string;
  amount: string;
  theme: ColourThemes;
  submitInitiator: SubmitInitiators;
  notifyCustomerAboutPaymentResult: boolean;
  version: Versions;
}

export const CASHIER_CONFIGURATION_FEATURE_KEY = 'cashierConfiguration';

export const initialCashierConfigurationState: CashierConfiguration = {
  accountId: '',
  activeType: null,
  amount: '',
  initialAmount: '',
  bonusCode: '',
  cashierHostLocation: '',
  country: '',
  currency: '',
  customerBalance: '',
  direction: Directions.Ltr,
  hostUrl: '',
  language: '',
  merchantId: '',
  orderId: '',
  pgwMerchantId: '',
  platform: '',
  sessionId: '',
  submitInitiator: SubmitInitiators.Self,
  termsUrl: '',
  theme: ColourThemes.Dark,
  userId: '',
  webView: false,
  notifyCustomerAboutPaymentResult: false,
  version: Versions.v2,
};

export const cashierConfigurationSlice = createSlice({
  name: CASHIER_CONFIGURATION_FEATURE_KEY,
  initialState: initialCashierConfigurationState,
  reducers: {
    initialiseCashierConfiguration: (
      state,
      action: PayloadAction<Partial<CashierConfiguration>>,
    ) => {
      const newConfiguration = {};

      Object.keys(action.payload).forEach((key) => {
        newConfiguration[key] =
          action.payload[key] || initialCashierConfigurationState[key];
      });
      state = { ...state, ...newConfiguration };

      return state;
    },
  },
});

export const cashierConfigurationReducer = cashierConfigurationSlice.reducer;

export const { initialiseCashierConfiguration } =
  cashierConfigurationSlice.actions;
